import React from "react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import HomeVideo from "../../asset/homevideo.mp4";
import "./Home.css";

const Banner = () => (
  <section className="home-banner" aria-labelledby="home-banner-title">
    <video className="home-banner__video" autoPlay muted loop playsInline preload="metadata" aria-hidden="true">
      <source src={HomeVideo} type="video/webm" />
    </video>
    <div className="home-banner__overlay" />
    <div className="home-banner__content">
      <p className="home-banner__eyebrow">Hardcoats India Pvt. Ltd.</p>
      <h1 id="home-banner-title">
        Precision engineered
        <span>for demanding applications.</span>
      </h1>
      <p className="home-banner__intro">
        High-performance components, coatings, and assemblies built around
        accuracy, reliability, and your most exacting requirements.
      </p>
      <div className="home-banner__actions">
        <Link to="/products" className="home-banner__primary">
          Explore products <ArrowRightIcon aria-hidden="true" />
        </Link>
        <Link to="/contact" className="home-banner__secondary">Talk to our team</Link>
      </div>
    </div>
  </section>
);

export default Banner;
